import app from "./app";

/**
 * Set of methods to manage threads/comments endpoints in backend
 */

/**
 * Method to create a new thread.
 *
 * @param {string} title
 * @param {object} point
 * @param {number} scenarioId
 * @param {string} color
 *
 * @returns
 */
export async function createThread(title, point, scenarioId, color) {
  const payload = {
    title: title,
    point: point,
    color: color,
    scenario: scenarioId
  };
  const res = await app.post(`/social/threads/`, payload);
  return res.data;
}

/**
 * Method to retirve all threads or a thread by id.
 *
 * @param {number} threadId
 * @returns
 */
export async function getThreads(threadId) {
  if (threadId) {
    const res = await app.get(`/social/threads/${threadId}/`, {});
    return res.data;
  } else {
    const res = await app.get(`/social/threads/`, {});
    return res.data;
  }
}

/**
 * Method to retirve all threads by project or scenario.
 *
 * @param {number} projectId
 * @param {number} scenarioId
 * @returns
 */
export async function getThreadsBy(projectId, scenarioId) {
  if (projectId && !scenarioId) {
    const res = await app.get(`/social/threads/fromproject/${projectId}/`, {});
    return res.data;
  } else if (scenarioId) {
    const res = await app.get(
      `/social/threads/fromscenario/${scenarioId}/`,
      {}
    );
    return res.data;
  }
}

/**
 * Method to retirve all threads by project.
 *
 * @param {number} threadId
 * @returns
 */
export async function getThreadsByProject(projectId) {
  const res = await app.get(`/social/threads/frompoject/${projectId}/`, {});
  return res.data;
}

/**
 * Method to retirve all threads by scenario.
 *
 * @param {number} threadId
 * @returns
 */
export async function getThreadsByScenario(scenarioId) {
  const res = await app.get(`/social/threads/fromscenario/${scenarioId}/`, {});
  return res.data;
}

/**
 * Method to patch a thread.
 *
 * @param {number} threadId
 * @param {object} body
 * @returns
 */
export async function patchThread(threadId, body) {
  const res = await app.patch(`/social/threads/${threadId}/`, body);
  return res.data;
}

/**
 * Method to delete a thread.
 *
 * @param {number} threadId
 * @returns
 */
export async function deleteThread(threadId) {
  const res = await app.delete(`/social/threads/${threadId}/`, {});
  return res.data;
}

/**
 * Method to create a new comment.
 *
 * @param {string} title
 * @param {number} threadId
 *
 * @returns
 */
export async function createComment(text, threadId) {
  const payload = {
    comment: text,
    object_pk: threadId
  };
  const res = await app.post(`/social/comments/`, payload);
  return res.data;
}

/**
 * Method to retirve all comments.
 *
 * @returns
 */
export async function getComments() {
  const res = await app.get(`/social/comments/`, {});
  return res.data;
}

/**
 * Method to retirve all comments by project or scenario.
 *
 * @param {number} projectId
 * @param {number} scenarioId
 * @returns
 */
export async function getCommentsBy(projectId, scenarioId) {
  if (projectId && !scenarioId) {
    const res = await app.get(`/social/comments/fromproject/${projectId}/`, {});
    return res.data;
  } else if (scenarioId) {
    const res = await app.get(
      `/social/comments/fromscenario/${scenarioId}/`,
      {}
    );
    return res.data;
  }
}

/**
 * Method to retirve all comments by project or scenario.
 *
 * @param {number} projectId
 * @param {number} scenarioId
 * @returns
 */
export async function searchCommentsBy(projectId, scenarioId, search = null) {
  if (projectId && !scenarioId) {
    const path = search
      ? `/social/comments/fromproject/${projectId}/?search=${search}`
      : `/social/comments/fromproject/${projectId}/`;
    const res = await app.get(path, {});
    return res.data;
  } else if (scenarioId) {
    const path = search
      ? `/social/comments/fromscenario/${scenarioId}/?search=${search}`
      : `/social/comments/fromscenario/${scenarioId}/`;
    const res = await app.get(path, {});
    return res.data;
  }
}
/**
 * Method to patch a comment.
 *
 * @param {number} commentId
 * @param {object} body
 * @returns
 */
export async function patchComment(commentId, body) {
  const res = await app.patch(`/social/comments/${commentId}/`, body);
  return res.data;
}

/**
 * Method to delete a comment.
 *
 * @param {number} commentId
 * @returns
 */
export async function deleteComment(commentId) {
  const res = await app.delete(`/social/comments/${commentId}/`, {});
  return res.data;
}

/**
 * Method to mark a  comment as read.
 *
 * @param {string} title
 * @param {number} threadId
 *
 * @returns
 */
export async function markAsReadComment(commentId) {
  const res = await app.post(`/social/comments/${commentId}/mark_as_read/`, {});
  return res.data;
}

/**
 * Method to mark a set of comments as read.
 *
 * @param {string} title
 * @param {number} threadId
 *
 * @returns
 */
export async function markAsReadComments(commentIds) {
  const res = await app.post(`/social/comments/batch/mark_as_read/`, {
    comment_ids: commentIds
  });
  return res.data;
}

/**
 * Method to retirve all comments.
 *
 * @returns
 */
export async function getNextComments(url) {
  const res = await app.get(url, {});
  return res.data;
}

/**
 * Method to retrieve the polling endpoints for the comment system.
 *
 * @returns
 */
export async function getPolling() {
  const res = await app.get(`/social/polling_endpoints/`, {});
  return res.data;
}
